import { render, staticRenderFns } from "./Opportunities.vue?vue&type=template&id=60045964"
import script from "./Opportunities.vue?vue&type=script&lang=js"
export * from "./Opportunities.vue?vue&type=script&lang=js"
import style0 from "./Opportunities.vue?vue&type=style&index=0&id=60045964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports